import React, {useContext, useEffect, useRef, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import {fetchPurchasePackageThunks} from "../../features/purchasePackage/purchasePackageThunks";
import DashboardItem from "./DashboardItem";
import {formatDateAsMonthStrDayYear, getRedirectType, isEmptyObject} from "../../utils/Utils";

import useD2C from "../../hooks/useD2C";
import usePurchasedPackage from "./usePurchasedPackage";
import BiometricMovementAndCautionQuestionContainer
    from "../shared/MovementModal/BiometricMovementAndCautionQuestionContainer";
import {Modal, ModalBody, ModalHeader} from "../modal/Modal";
import GLOBAL from "../../global";
import useChatbot from "../shared/chatbotNew/hooks/useChatbot";
import examService from "../../services/ExamService";
import CONSTANT from "../../constants/Constant";
import {
    setIsShowIsFollowUpPopup, setOpenBiometricMovementAndCautionQuestionContainer,
    setSelectedTelemedicineInvitationId,
    setShowLoadingAtJoinNowBtn, setShowLoadingInConformTelemedicine
} from "../../features/dashboard/dashboardSlice";
import useSweetAlert from "../shared/Popups/sweetAlertComponent/useSweetAlert";
import AppContext from "../../contexts/AppContext";
import {_getInCompleteAssessmentType, getResumeGroupFromId} from "./dashboardUtills";
import routes from "../../constants/Routes";
import {useHistory} from "react-router-dom";
import DirectToConsumerService from "../../services/DirectToConsumerService";
import {toast} from "react-toastify";
import {PlusIcon} from "../../assets/svg/AlertModal/plus";
import {ReloadIcon} from "../../assets/svg/AlertModal/reload";
import AlertModal from "../AlertModal/AlertModal";

const PurchasedPackage = ({ callbackFetchNotificationData }) => {
    const [showAssessmentPurchaseModal, setShowAssessmentPurchaseModal] = useState(false);
    const [invitationRequestResponse, setInvitationRequestResponse] = useState(false);
    const dispatch = useDispatch();
    const { IsD2CEnabled } = useD2C();
    const { createAssessmentFromPackage } = usePurchasedPackage();
    const { startChatBot } = useChatbot();
    const { showSweetAlert, hideSweetAlert } = useSweetAlert();
    const { setTelemedicineProperties, resetTelemedicineKeys, setSelectedTabForEditAssessment } = useContext(AppContext);
    const history = useHistory();


    const notificationInformationOfSelectedAssessment = useRef({});

    const purchasePackageState = useSelector(state => state.purchasePackage);
    const packages = purchasePackageState.packages || [];
    const purchasePackageIsLoading = purchasePackageState?.isLoading || false;

    useEffect(() => {
        if(IsD2CEnabled) {
            dispatch(fetchPurchasePackageThunks());
        }
    }, [dispatch]);

    const onConfirmNewAssessment = async () => {
        let response = await DirectToConsumerService.invitationRequest({ OrderId : invitationRequestResponse?.OrderId });
        if (response.success) {
            const data = response?.data;
            if (data && data?.InvitationId && data?.InvitationTypeId && data?.BodyRegionIds && data?.MeetingStartDate && data?.MeetingEndDate) {
                const bodyRegionList = data?.BodyRegionIds.split(',').map(Number).filter(Boolean) || []

                startChatBot(
                    {
                        InvitationId: data?.InvitationId,
                        BodyRegionList: bodyRegionList,
                        InvitationTypeName: getRedirectType(data?.InvitationTypeId),
                    },
                    GLOBAL?.USER_INFO?.ContactId || '', //patientId
                    data?.MeetingEndDate || '', //meetingStart
                    data?.MeetingStartDate || '', //meetingEnd
                    () => {
                        // Callback after chatbot starts
                        setShowAssessmentPurchaseModal(false);
                    }
                )
            }
            setShowAssessmentPurchaseModal(false);
        } else {
            toast.error("Failed to start assessment, please try again later");
        }
    };

    const onOpenTelemedicineModal = () => {
        setIsShowIsFollowUpPopup(false);
    };

    const onCloseTelemedicineModal = () => {
        resetTelemedicineKeys();
        dispatch(setSelectedTelemedicineInvitationId(null));
        dispatch(setShowLoadingAtJoinNowBtn(false));
        dispatch(setShowLoadingInConformTelemedicine(false));
    };

    const openBiometricCautionQuestionModal = (notification) => {
        dispatch(setOpenBiometricMovementAndCautionQuestionContainer({
            openBiometricMovementAndCautionQuestionContainer: true,
            testId: notification.TestId,
            selectedBodyRegions: notification.BodyRegionList
        }));
    }

    const redirectToEditAssessmentPage = (notification) => {
        notificationInformationOfSelectedAssessment.current = notification
        let firstInCompletedGroup = getResumeGroupFromId(notification?.ResumeGroupId);
        let keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
        if(!isEmptyObject(firstInCompletedGroup)) {
            keyOfFirstIncompleteGroup = firstInCompletedGroup?.key || CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key;
            if(keyOfFirstIncompleteGroup === CONSTANT.ASSESSMENT_GROUP.BIOMETRIC.key) keyOfFirstIncompleteGroup = CONSTANT.ASSESSMENT_GROUP.DEMOGRAPHICS.key
        }
        setSelectedTabForEditAssessment(keyOfFirstIncompleteGroup);

        // setRedirectToAssessmentPage(true)
        // redirectTo(`${routes.editAssessment}/${notificationInformationOfSelectedAssessment.current.TestId}?groupId=${getResumeGroupFromId(notificationInformationOfSelectedAssessment.current?.ResumeGroupId)?.key}`)
        history.push(`${routes.editAssessment}/${notificationInformationOfSelectedAssessment.current.TestId}?groupId=${getResumeGroupFromId(notificationInformationOfSelectedAssessment.current?.ResumeGroupId)?.key}`)
    }

    const onCancelFollowUpAssessment = async () => {
        if (!invitationRequestResponse) return;

        let invitationRequestApiResponse = await DirectToConsumerService.invitationRequest({ OrderId : invitationRequestResponse?.OrderId });
        if (invitationRequestApiResponse.success) {
            const invitationRequestResponse = invitationRequestApiResponse?.data;
            const response = await examService.followUp({
                InvitationId: invitationRequestResponse.InvitationId,
                BaseTestId: invitationRequestResponse.BaseTestId,
                StartTime: invitationRequestResponse.MeetingStartDate,
                EndTime: invitationRequestResponse.MeetingEndDate,
                TimeZone: invitationRequestResponse.TimeZone
            });
            const { data, success, error } = response;

            if (success) {
                setShowAssessmentPurchaseModal(false);
                showSweetAlert({
                    title: 'Update Your Information?',
                    message: 'Would you like to update your background information (Activities of Daily Living, Medical History, Chief Complaints)?',
                    type: CONSTANT.ALERT_TYPE.INFO,
                    onConfirm: () => {
                        hideSweetAlert();
                        if (+invitationRequestResponse?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Telemedicine) {
                            setTelemedicineProperties(invitationRequestResponse.InvitationId, invitationRequestResponse.BodyRegionList, onOpenTelemedicineModal, onCloseTelemedicineModal);
                            dispatch(setSelectedTelemedicineInvitationId(invitationRequestResponse.InvitationId));
                        } else if (+invitationRequestResponse?.InvitationTypeId === CONSTANT.INVITATION_TYPE.Self) {
                            openBiometricCautionQuestionModal({
                                ...invitationRequestResponse,
                                TestId: data.TestId
                            });
                        } else {
                            // Do nothing
                        }
                    },
                    onClose: () => {
                        hideSweetAlert();
                    },
                    showCloseBtn: true,
                    onCancel: () => {
                        hideSweetAlert();
                        redirectToEditAssessmentPage({...invitationRequestResponse, TestId: data.TestId});
                    },
                    showCancelBtn: true,
                    showConfirmBtn: +invitationRequestResponse?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic,
                    showOkBtn: false,
                    confirmBtnText: +invitationRequestResponse?.InvitationTypeId !== CONSTANT.INVITATION_TYPE.InClinic ? 'Resume Assessment' : '',
                    cancelBtnText: 'Update My Background',
                });
            }
        } else {
            toast.error("Failed to start assessment, please try again later");
        }
    };

    const toggleAssessmentPurchaseModal = () => {
        setShowAssessmentPurchaseModal(false);
    };

    const InfoIcon = () => (
        <svg fill="#ffffff" width="800px" height="800px" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" data-name="Layer 1"><path d="M12,14a1,1,0,0,0,1-1V7a1,1,0,0,0-2,0v6A1,1,0,0,0,12,14Zm0,4a1.25,1.25,0,1,0-1.25-1.25A1.25,1.25,0,0,0,12,18Z" /></svg>
    );

    return (
        <div className="purchase-package">
            {(packages.length > 0 && IsD2CEnabled) && (
                <DashboardItem largeTitle={`Packages`} overflow={true} showOnlyOneImage={false}>
                    <div className="table dashboard-item-wrapper overflow-y-auto white-space-pre" style={{paddingLeft: '0 !important'}}>
                        <table className="table__content ">
                            <thead className="table__header ">
                            <tr className="table__row">
                                <th className="table__cell table__cell--header table__cell--header--title">Current Package</th>
                                <th className="table__cell table__cell--header table__cell--header--small text-align-center">Screening Details & Status</th>
                                <th className="table__cell table__cell--header table__cell--header--small text-align-center">Not Availed</th>
                                <th className="table__cell table__cell--header table__cell--header--small">Expired Date</th>
                                <th className="table__cell table__cell--header table__cell--header--small"></th>
                            </tr>
                            </thead>
                            <tbody className="table__body">
                            {packages.map((pak, index) => (
                                <tr key={index} className="table__row table__row--body">
                                    <td className="table__cell table__cell--title bg-white">{pak.packageName}</td>
                                    <td className="table__cell table__cell--small text-align-center bg-white d-flex border-bottom-0 border-right-0 border-left-0 w-100 p-0 m-0">
                                        <div className="h-100 w-50">{pak.assessmentCount || 0}</div>

                                        <div className="h-100 w-50 border-left">
                                            <div className="my-2 border-bottom">Completed: {pak.noOfComplete || 0}</div>

                                            <div className="my-2">In Progress: {pak.noOfInProgress || 0}</div>
                                        </div>
                                    </td>
                                    <td className="table__cell table__cell--small bg-white text-align-center">{pak.balance || 0}</td>
                                    <td className="table__cell table__cell--small bg-white">{formatDateAsMonthStrDayYear(pak.expireDate)}</td>
                                    <td className="table__cell table__cell--small bg-white">
                                        {pak.isExpired && (
                                            <span className="color-dark-gray">Expired</span>
                                        )}
                                        {pak.balance > 0 && !pak.isExpired && (
                                                <button
                                                    className="button button-dashboard"
                                                    onClick={() => createAssessmentFromPackage(pak?.orderId, callbackFetchNotificationData, setShowAssessmentPurchaseModal, setInvitationRequestResponse)}
                                                    disabled={purchasePackageIsLoading}
                                                >
                                                    Start
                                                </button>
                                            )
                                        }
                                    </td>
                                </tr>
                            ))}
                            </tbody>
                        </table>

                        {showAssessmentPurchaseModal && (
                            <AlertModal
                                isOpen={showAssessmentPurchaseModal}
                                onClose={() => toggleAssessmentPurchaseModal()}
                                icon={<InfoIcon />}
                                title="What would you like to do today?"
                                description={
                                    <>
                                        <p style={{ marginBottom: '0.75rem' }}>
                                            <strong>New:</strong> Start a new assessment with a different sport selection.
                                        </p>
                                        <p style={{ textWrap: "wrap" }}>
                                            <strong>Follow Up:</strong> Continue from your last assessment update background details if needed or go straight to biometric movement.
                                        </p>
                                    </>
                                }
                                buttons={[
                                    {
                                        label: 'New',
                                        icon: <PlusIcon />,
                                        variant: 'primary',
                                        onClick: onConfirmNewAssessment,
                                    },
                                    {
                                        label: 'Follow Up',
                                        icon: <ReloadIcon />,
                                        variant: 'primary',
                                        onClick: onCancelFollowUpAssessment,
                                    },
                                ]}
                                overlayClosable={false}
                                showCloseButton={false}
                            />
                        )}

                    </div>
                </DashboardItem>
            )}
        </div>
    );
}

export default PurchasedPackage;
